import { defineComponent as _defineComponent } from 'vue'
import { onMounted, PropType } from 'vue'
import LfBlueTitleComponent from '@/components/HeaderTitle/LfBlueTitleComponent.vue'
import { IFacturaEDialogModel } from '@/components/billing/FacturaEDialog/types/FacturaEDialogTypes'
import useActionsFacturaEDialog from '@/components/billing/FacturaEDialog/composables/useActionsFacturaEDialog'
import { useI18n } from 'vue-i18n-composable'
import LfSimpleProgressBarComponent from '@/components/ProgressBar/LfSimpleProgressBarComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SendingComponent',
  props: {
  model: {
    type: Object as PropType<IFacturaEDialogModel>,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { t } = useI18n()
const texts = {
  title: t('components.facturae_dialog.validator.title').toString(),
  caption: 'Enviando factura electrónica...',
}

const icon = 'lf-icon-document-validate'

const { send } = useActionsFacturaEDialog(props.model)

onMounted(async () => await send())


return { __sfc: true,props, t, texts, icon, send, LfBlueTitleComponent, LfSimpleProgressBarComponent }
}

})